import { Helmet } from 'react-helmet-async';
import React from 'react';
import { getOrgTermsContent } from '../../../content/utils.js';
import requireAuth from '../../../lib/requireAuth.jsx';
import withRouterParams from '../../../lib/withRouterParams.jsx';

import StepMilestonesFormContainer from '../../../containers/portfolio/PortfolioFormContainers/StepMilestonesFormContainer.jsx';

const EditChangeStrategyStepMilestones = ({ portfolioId, slug }) => (
  <>
    <Helmet>
      <title>Edit {getOrgTermsContent('portfolio')} | ChangeSync</title>
    </Helmet>
    <StepMilestonesFormContainer portfolioId={portfolioId} slug={slug} />
  </>
);

EditChangeStrategyStepMilestones.getInitialProps = ({ query }) => ({
  portfolioId: Number(query.portfolioId),
  slug: query.slug,
});
export default requireAuth(withRouterParams(EditChangeStrategyStepMilestones));
